import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   createActualAdhocApiCall,
   getAdhocTripApiCall,
   getAdhocTripByPaginationApiCall,
   getSingleAdhocTripApiCall,
   updateAdhocTripManagerApiCall,
   updateAdhocTripReviewStatusApiCall,
   updateTripManagerApiCall,
   updateTripReviewStatusApiCall,
} from "../../Api/api";

const initialState = {
   allTrips: [],
   singleTrip: null,
   isLoading: false,
   isError: false,
   isSuccess: false,
};

// Fetch All adhoc trip list
export const adhocTripListAsync = createAsyncThunk(
   "trip/adhoc/triplist",
   async ({ role, done, err }, thunkAPI) => {
      try {
         const { data: response } = await getAdhocTripApiCall(role);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Fetch All adhoc trip list
export const adhocTripListByPaginationAsync = createAsyncThunk(
   "trip/adhoc/triplist-by-pagination",
   async ({ role, limit, offset, done, err }, thunkAPI) => {
      try {
         const { data: response } = await getAdhocTripByPaginationApiCall(
            role,
            limit,
            offset
         );
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Fetch single trip
export const adhocSingleTripAsync = createAsyncThunk(
   "trip/adhoc/singleTrip",
   async ({ id, done, err }, thunkAPI) => {
      try {
         const { data: response } = await getSingleAdhocTripApiCall(id);

         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Update trip manager
export const adhocTripUpdateManagerAsync = createAsyncThunk(
   "trip/adhoc/updateTrip",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateAdhocTripManagerApiCall(data);
         if (response.statusCode === 200) {
            done && done();
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Update trip review status
export const updateTripReviewStatusAsync = createAsyncThunk(
   "trip/adhoc/update-review-status",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateTripReviewStatusApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Update trip review status
export const updateAdhocTripReviewStatusAsync = createAsyncThunk(
   "trip/adhoc/update-adhoc-review-status",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateAdhocTripReviewStatusApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

export const createActualAdhocAsync = createAsyncThunk(
   "/trip/adhoc/add-more",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const { data: response } = await createActualAdhocApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

const adhocTipSlice = createSlice({
   name: "trip",
   initialState: initialState,

   reducers: {
      clearTrip: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },
   extraReducers: (builder) => {
      builder
         .addCase(adhocTripListAsync.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(adhocTripListAsync.fulfilled, (state, action) => {
            state.allTrips = action.payload;
            state.isLoading = false;
         })
         .addCase(adhocTripListAsync.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
         });

      builder
         .addCase(adhocTripListByPaginationAsync.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(adhocTripListByPaginationAsync.fulfilled, (state, action) => {
            console.log({action})
            state.allTrips = action.payload?.data;
            state.listPagination = action.payload?.pagination;
            state.isLoading = false;
         })
         .addCase(adhocTripListByPaginationAsync.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
         });

      builder
         .addCase(adhocSingleTripAsync.pending, (state, action) => {
            state.isLoading = true;
            state.singleTrip = null;
         })
         .addCase(adhocSingleTripAsync.fulfilled, (state, action) => {
            state.singleTrip = action.payload;
            state.isLoading = false;
         })
         .addCase(adhocSingleTripAsync.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
         });

      builder.addCase(createActualAdhocAsync.pending, (state, action) => {});
      builder.addCase(createActualAdhocAsync.fulfilled, (state, action) => {});
      builder.addCase(createActualAdhocAsync.rejected, (state, action) => {});
   },
});

export const { clearTrip } = adhocTipSlice.actions;

const adhocTripReducer = adhocTipSlice.reducer;
export default adhocTripReducer;
